module.exports = __webpack_public_path__ + "static/media/progress_modell.976cbd6f.svg";